export default __webpack_public_path__ + "static/media/Customer_Service.5d6ec5c2.jpg";